import _get from 'lodash/get';
import * as SensorTypes from 'services/config/SensorTypes';

// Every sensor reports a battery state. Cloud Connectors have no battery.
export const BATTERY_POWERED_DEVICE_TYPES = Object.keys(SensorTypes).filter(type => type !== 'ccon');

export const BATTERY_STATE_SEVERITY = {
    CRITICAL: 0,
    LOW: 1,
    OK: 2,
    UNKNOWN: 3
};

export function getBatteryStateLabel(device) {
    const state = _get(device, 'reported.batteryStatus.state');
    if (state === 'OK') return 'OK';
    if (state === 'LOW') return 'Low';
    if (state === 'CRITICAL') return 'Critical';
    return null;
}

export function getBatteryIcon(device) {
    const state = _get(device, 'reported.batteryStatus.state');
    if (state === 'OK') return 'battery_healthy';
    if (state === 'LOW') return 'battery_low';
    if (state === 'CRITICAL') return 'battery_warning';
    return null;
}

export function getBatteryStateBadgeClass(device) {
    const state = _get(device, 'reported.batteryStatus.state');
    if (state === 'OK') return 'battery battery__ok';
    if (state === 'LOW') return 'battery battery__low';
    if (state === 'CRITICAL') return 'battery battery__critical';
    return '';
}

// Per-state positioning modifier for the absolutely-positioned info-hint ("?")
// next to the battery badge in device tables. Wider labels (Critical) need the
// "?" pushed further right so it doesn't overlap the badge text. (SOL-292)
export function getBatteryInfoHintClass(device) {
    const state = _get(device, 'reported.batteryStatus.state');
    if (state === 'LOW') return 'battery-info-hint--low';
    if (state === 'CRITICAL') return 'battery-info-hint--critical';
    return 'battery-info-hint--ok';
}

export function getBatteryPercentage(device) {
    const value = _get(device, 'reported.batteryStatus.percentage', null);
    return value !== null ? Number(value) : null;
}

export function getBatteryTooltipSentence(device) {
    const state = _get(device, 'reported.batteryStatus.state');
    if (state === 'OK') return 'The sensor is expected to continue operating for more than one year.';
    if (state === 'LOW') return 'The sensor is expected to operate for less than one year. Plan for replacement or review the connectivity of the installation.';
    if (state === 'CRITICAL') return 'The sensor may stop working at any time, and should be replaced.';
    return null;
}

export function getEstimatedRemainingYears(device) {
    const value = _get(device, 'reported.batteryStatus.estimatedRemainingYears', 0);
    if (!value || value <= 0) return null;
    // Round to 0.5 years (consistent with sensor details page)
    return Math.round(value * 2) / 2;
}

// UI display variant of getEstimatedRemainingYears: caps values above 10 years
// to the string '10+'. Used in tooltips/badges where extra precision (e.g.
// "11.5 years") looks odd; the raw helper above is still used for the CSV
// export and for ng-if truthiness checks.
export function getEstimatedRemainingYearsDisplay(device) {
    const value = getEstimatedRemainingYears(device);
    if (value === null) return null;
    if (value > 10) return '10+';
    return value;
}
